// services/branchService.js
import { branchesAPI } from './api';

export const branchService = {
  async getBranches() {
    try {
      const response = await branchesAPI.getAll();
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching branches:', error);
      throw new Error(error.response?.data?.message || 'Failed to load branches');
    }
  },

  async getBranch(id) {
    try {
      const response = await branchesAPI.getById(id);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching branch:', error);
      throw new Error(error.response?.data?.message || 'Failed to load branch');
    }
  },

  async createBranch(branch) {
    try {
      console.log('📤 Creating branch:', branch);
      const response = await branchesAPI.create(branch);
      console.log('✅ Branch created:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error creating branch:', error);
      const errorMessage = error.response?.data?.title || 
                          error.response?.data?.message || 
                          error.response?.data || 
                          'Failed to create branch';
      throw new Error(errorMessage);
    }
  },

  async updateBranch(id, branch) {
    try {
      console.log(`📤 Updating branch ${id}:`, branch);
      const response = await branchesAPI.update(id, branch);
      console.log('✅ Branch updated:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error updating branch:', error);
      const errorMessage = error.response?.data?.title || 
                          error.response?.data?.message || 
                          error.response?.data || 
                          'Failed to update branch';
      throw new Error(errorMessage);
    }
  },

  async deleteBranch(id) {
    try {
      await branchesAPI.delete(id);
    } catch (error) {
      console.error('❌ Error deleting branch:', error);
      throw new Error(error.response?.data?.message || 'Failed to delete branch');
    }
  }
};

// services/departmentService.js
import { departmentsAPI } from './api';

export const departmentService = {
  async getDepartments() {
    try {
      const response = await departmentsAPI.getAll();
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching departments:', error);
      throw new Error(error.response?.data?.message || 'Failed to load departments');
    }
  },

  async createDepartment(department) {
    try {
      const response = await departmentsAPI.create(department);
      return response.data;
    } catch (error) {
      console.error('❌ Error creating department:', error);
      throw new Error(error.response?.data?.message || 'Failed to create department');
    }
  },

  async updateDepartment(id, department) {
    try {
      const response = await departmentsAPI.update(id, department);
      return response.data;
    } catch (error) {
      console.error('❌ Error updating department:', error);
      throw new Error(error.response?.data?.message || 'Failed to update department');
    }
  },

  async deleteDepartment(id) {
    try {
      await departmentsAPI.delete(id);
    } catch (error) {
      console.error('❌ Error deleting department:', error);
      throw new Error(error.response?.data?.message || 'Failed to delete department');
    }
  }
};

// services/divisionService.js
import { divisionsAPI } from './api';

export const divisionService = {
  async getDivisions() {
    try {
      const response = await divisionsAPI.getAll();
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching divisions:', error);
      throw new Error(error.response?.data?.message || 'Failed to load divisions');
    }
  },

  async createDivision(division) {
    try {
      const response = await divisionsAPI.create(division);
      return response.data;
    } catch (error) {
      console.error('❌ Error creating division:', error);
      throw new Error(error.response?.data?.message || 'Failed to create division');
    }
  },

  async updateDivision(id, division) {
    try {
      const response = await divisionsAPI.update(id, division);
      return response.data;
    } catch (error) {
      console.error('❌ Error updating division:', error);
      throw new Error(error.response?.data?.message || 'Failed to update division');
    }
  },

  async deleteDivision(id) {
    try {
      await divisionsAPI.delete(id);
    } catch (error) {
      console.error('❌ Error deleting division:', error);
      throw new Error(error.response?.data?.message || 'Failed to delete division');
    }
  }
};